const featureFlags = {
    AD_CREATE_ENABLED: true,
    ASSETS_UI: true,
    BILLING_CANCEL_PLAN_ENABLED: true,
    CHURNKEY_APP_ID: '5dd9uhvls',
    CONCEPTS_ENABLED: true,
    DISCOVER_FOR_YOU_ENABLED: true,
    DIRECTORIES: true,
    FACEBOOK_API_VERSION: 'v22.0',
    FACEBOOK_APP_ID: '1548574282349689',
    FACEBOOK_APP_LOGIN_CONFIG_ID: '345128978470471',
    FACEBOOK_ASSET_PRODUCT_IMAGE_INGESTION_ENABLED: true,
    FACEBOOK_CONNECT_USE_ROLES_ENABLED: true,
    FIREBASE_CLIENT_EMAIL: 'firebase-adminsdk-x7cj8@magicbrief-development.iam.gserviceaccount.com',
    FIREBASE_PROJECT_ID: 'magicbrief-development',
    FOR_YOU_PAGE: false,
    GTM_CONTAINER_ID: 'GTM-PDGN84FW',
    HOCUSPOCUS_PATH: '/ws2',
    INSIGHTS_BREAKDOWNS_ADDITIONAL_ENABLED: true,
    INSIGHTS_COMPARE_GROUPS_ENABLED: true,
    INSIGHTS_COPILOT_ENABLED: true,
    INSIGHTS_DASHBOARD_ENABLED: true,
    INSIGHTS_DASHBOARD_VERSION: 6,
    INSIGHTS_DISPLAY_METRICS_V2_ENABLED: true,
    INSIGHTS_GUEST_USERS_ENABLED: true,
    INSIGHTS_REPORT_SHARING_ENABLED: true,
    INSIGHTS_TIK_TOK_ENABLED: true,
    INSIGHTS_TIME_PERIOD_FILTER_V2_ENABLED: true,
    JOB_AD_SEARCH_INGESTOR_ENABLED: false,
    JOB_CUSTOM_SCHEDULED_JOB_PROCESSOR_ENABLED: true,
    JOB_RELAY_NOTIFICATIONS_RELAY_SCHEDULE_SECONDS: 30,
    MAGICAI_VERSION: 'no version provided',
    MAIL_SERVICE_AUTH_USER: 'api',
    MAIL_SERVICE_FROM: 'donotreply@magicbrief.com',
    MAIL_SERVICE_HOST: 'send.smtp.mailtrap.io',
    MAIL_SERVICE_PORT: 587,
    MAILTRAP_SENDER_EMAIL: 'noreply@magicbrief.com',
    MAILTRAP_SENDER_NAME: 'MagicBrief',
    MAILTRAP_TEMPLATE_UUID_BOARD_INVITE: '36e3c459-45e4-45c2-94fa-3f04d1fba3a5',
    MAILTRAP_TEMPLATE_UUID_BRIEF_INVITE: 'f6160a4f-4ba9-4427-9b66-5580a3c86ff7',
    MAILTRAP_TEMPLATE_UUID_BRIEF_ASSIGNED_UPDATE: 'fa25fd39-4f91-449e-b129-eaf63566cc83',
    MAILTRAP_TEMPLATE_UUID_BRIEF_DUE_DATE_UPDATE: '2844a4a6-9374-4032-bccb-c29d027e23e6',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STAGE_UPDATE: 'e4204a97-f97a-43de-95ee-30fd13e78d0c',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STATUS_UPDATE: 'db4f345c-d77f-4d8c-98ed-0be5d9cdac01',
    MAILTRAP_TEMPLATE_UUID_COMMENT_MENTION: '5a69e27a-bf0e-4a9f-8ea0-e77f3f648f94',
    MAILTRAP_TEMPLATE_UUID_INSIGHTS_AD_INVITE: '47bcff6b-e53b-428e-8305-6ce8d8612aac',
    MAILTRAP_TEMPLATE_UUID_INSIGHTS_REPORT_INVITE: '98a2e7ae-bd72-4c46-8daf-b8e7a2a772ee',
    MAILTRAP_TEMPLATE_UUID_ORGANISATION_INVITE: '9a9891b0-af26-494f-beb6-a8dcca4004ba',
    MB_API_URL: 'http://localhost:12500',
    MB_CLIENT_URL: 'http://localhost:3000',
    MB_SHARE_URL: 'http://localhost:12600',
    NOTIFICATIONS_EMAIL: false,
    NOTIFICATIONS_IN_APP: false,
    REGO_SLACK_REPORTING: false,
    REGO_SLACK_URL: '',
    PRESENCES: false,
    PYLON_APP_ID: '5bc8060c-0680-4adf-8de4-4ae951b5506a',
    USE_PROXY: false,
    SCREENSHOT_FUNCTION_URL: 'https://screenshot.functions.com',
    SHOW_MAGIC_AI_SCENES: false,
    SEARCH_ENGINE: 'mb',
    SEARCH_VERSION: 'v2',
    SENTRY_DSN_API: 'https://d580afbde6f84287a869cdd9ef6c254d@o4504063794348032.ingest.sentry.io/4504063806406657',
    SENTRY_DSN_JOBS: 'https://4d2fbacff9fc394b4a3d0e5bc1cbcdca@o4504063794348032.ingest.sentry.io/4506193515184128',
    SERVER_PORT: 12500,
    SEGMENT_KEY_V3: 'bing-bong-bang',
    SHORT_URL: 'https://test.mb.co',
    SHOW_GPT_BOARDS: true,
    SLACK_CLIENT_ID: '3631056502098.6699285064194',
    SLACK_DEBUG_URL: '',
    SLACK_REDIRECT_URI: 'http://localhost:3000/slack/oauth',
    SLACK_REDIRECT_URI_PATH: '/slack/oauth',
    SLACK_WEBHOOK_AD_ACCOUNT_EVENTS_URL: '',
    SLACK_WEBHOOK_EVENTS_BRANDS: '',
    SLACK_WEBHOOK_URL: '',
    SOCKET_IO_PATH: '/ws1',
    SYNC_TO_TYPESENSE: true,
    TIK_TOK_API_VERSION: 'v1.3',
    TIK_TOK_APP_ID: '7382050893274808337',
    YOUTUBE_INTEGRATION_ENABLED: false,
    YOUTUBE_CLIENT_ID: '722421198048-seosob5tqo8q4b65tumd7ra45lghapmi.apps.googleusercontent.com',
    YOUTUBE_REDIRECT_URI: '',
    TIK_TOK_OAUTH_URL: 'https://business-api.tiktok.com/portal/auth?app_id=7382050893274808337&redirect_uri=https%3A%2F%2Ftest.mb.co%2Ft%2Foauth',
    USER_HYDRATE_HAS_QUALIFIED_EMAIL: true,
    WIZARD_JOB_CALLBACK_URL: 'http://localhost:12500/api/v1/wizard_jobs/handle_asset',
    WIZARD_JOB_WEBHOOK_URL: 'http://127.0.0.1:12765/api/v1/process_asset',
};
export default featureFlags;
//# sourceMappingURL=test.js.map